import { useEffect, useState } from "react";
import { useMediaQuery } from "@material-ui/core";
import { mobile } from "styles/breakpoints";
import { Video } from "components/video";

export const EligibilityVideo = ({
  videoUrl,
}: {
  videoUrl: string | undefined;
}) => {
  const [portraitVideoAvailable, setPortraitVideoAvailable] = useState(false);

  const isMobileView = useMediaQuery(`(max-width:${mobile}px)`);

  const _videoUrl = videoUrl || "";
  const splitUrl = _videoUrl.split("/");
  const fileName = splitUrl[splitUrl.length - 1];
  const portraitFileName = fileName.replace(".mp4", "_portrait.mp4");
  const portraitVideoUrl = _videoUrl.replace(fileName, portraitFileName);

  useEffect(() => {
    const fetchVideo = async () => {
      const response = await fetch(portraitVideoUrl);

      if (response.ok) {
        setPortraitVideoAvailable(true);
      }
    };

    fetchVideo();
  }, [portraitVideoUrl]);

  return (
    <Video
      src={isMobileView && portraitVideoAvailable ? portraitVideoUrl : videoUrl}
    />
  );
};
